/**
 * Definisce un mixin specifico per i templates degli articoli dei fornitori
 * dove raggruppare le proprietà ed i metodi comuni a tutti i templates.
 */
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

const templateMixin = {
  computed: {
    /**
     * Sulla base dell'indirizzo del fornitore calcola il
     * link per google maps usando la funzione di libreria.
     */
    google_map_link : function () {
      return generalLib.google_map_link( this.dati_fornitore.comune, this.dati_fornitore.cap,
                                         this.dati_fornitore.provincia, this.dati_fornitore.indirizzo );
    }
  },
  methods: {
    /**
     * Esegue l'acquisto chiamando il backend.
     * Emette tre eventi corrispondenti ad altrettante fasi di acquisto che possono essere utili
     * ad esempio nel contenitore padre per la visualizzazione dell'overlay oppure per effettuare
     * altre operazioni.
     * - onAcqSubmit  : viene emesso all'ok sulla finestra di conferma acquisto.
     * - onAcqComplete: viene emesso se l'acquisto si completa correttamente prima che il messaggio
     *                  di completamento sia visualizzato.
     * - onAcqError   : viene emesso se l'acquisto va in errore, prima della visualizzazione della
     *                  finestra di errore.
     */
    esegui_acquisto : function () {

      // Visualizzo la modale di conferma, il credito è sempre quello 'totale'
      // visto che ora possiamo vendere beni direttamente dai fornitori solo in
      // convenzione.
      generalLib.acquisto_confirm_message_box (  this, this.dati_articolo.prezzo_unitario, 'totale' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla.
        if ( !value ) return;

        // Notifico che sto per inviare i dati
        this.$emit( 'onAcqSubmit', null )

        // Preparo le informazioni da inviare per effettuare l'acquisto
        let data = { id_articolo : this.dati_articolo.id,
                     id_fornitore : this.dati_fornitore.id,
                     codice_articolo : this.dati_articolo.codice_articolo }

        axios.post( apiUrl.welfareapi.create_acq_convwfbit , data )
        .then( (response) => {

          // Notifico che l'acquisto è avvenuto con successo
          this.$emit( 'onAcqComplete', null )

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home.
          generalLib.acquisto_complete_message_box( this, response.data.id_acquisto )
          .then ( () => {
              this.$router.push( { name : 'menu'} );
          });

        })
        .catch( (error) => {
          // Notifico che l'acquisto è andato in errore
          this.$emit( 'onAcqError', null )
          generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });
    }
  },
  props : {
    /**
     * Oggetto con i dati dell'articolo.
     * Mandatorio.
     */
    dati_articolo: {
      type: Object,
      required: true
    },
    /**
     * Oggetto con i dati del fornitore
     * Mandatorio.
     */
    dati_fornitore: {
      type: Object,
      required: true
    }
  }
}

export { templateMixin };